const defaults = {
    diagonal: false,
    parser: (grid, index) => grid[index] > 0 ? 1 : 0,
}

export class Graph {
    constructor(flatGrid, width, height, opts) {
        this.width = width;
        this.height = height;
        this.nodes = [];

        this.options = Object.assign({}, defaults, opts);

        this.init(flatGrid);
    }

    init(flatGrid) {
        let xy;
        for (let i = 0; i < flatGrid.length; i++) {
            xy = this.getXY(i);
            this.nodes.push(new Node(i, xy, this.options.parser(flatGrid, i)));
        }
    }

    iterNodes(fn) {
        this.nodes.forEach(node => {
            fn(node);
        });
    }

    getXY(index) {
        return { x: index % this.width, y: Math.floor(index / this.width) };
    }

    getIndex(x, y) {
        return x + y * this.width;
    }

    getNodeFromXY(xy) {
        return this.nodes[this.getIndex(xy.x, xy.y)];
    }

    getNeighbours(node) {
        let neighbours = [];

        if (node.index - this.width >= 0) neighbours.push(this.nodes[node.index - this.width]); // North
        if (node.index % this.width !== 0) neighbours.push(this.nodes[node.index - 1]); // West
        if ((node.index + 1) % this.width !== 0) neighbours.push(this.nodes[node.index + 1]); // East
        if (node.index + this.width < this.nodes.length) neighbours.push(this.nodes[node.index + this.width]); // South

        if (this.options.diagonal) {
            if (node.index - this.width - 1 >= 0 && node.index % this.width !== 0)
                neighbours.push(this.nodes[node.index - this.width - 1]); // NorthWest

            if (node.index - this.width + 1 >= 0 && (node.index + 1) % this.width !== 0)
                neighbours.push(this.nodes[node.index - this.width + 1]); // NorthEast

            if (node.index + this.width - 1 < this.nodes.length && node.index % this.width !== 0)
                neighbours.push(this.nodes[node.index + this.width - 1]); // SouthWest

            if (node.index + this.width + 1 < this.nodes.length && (node.index + 1) % this.width !== 0)
                neighbours.push(this.nodes[node.index + this.width + 1]); // SouthEast
        }

        return neighbours;
    }

    setNode(xy, isBlocking) {
        let node = this.getNodeFromXY(xy);
        if (node) node.weight = isBlocking ? 0 : 1;
    }

    toString() {
        let graphString = [],
            rowString;

        for (let y = 0; y < this.height; y++) {
            rowString = []
            for (let x = 0; x < this.width; x++) {
                rowString.push(this.nodes[this.getIndex(x, y)].weight);
            }
            graphString.push(rowString.join(" "));
        }

        return graphString.join("\n");
    }
}

export class Node {
    constructor(index, xy, weight) {
        this.index = index;
        this.x = xy.x;
        this.y = xy.y;
        this.weight = weight;
    }

    getCost(neighbour) {
        return neighbour ?.x !== this.x && neighbour ?.y !== this.y ?
            this.weight * Math.SQRT2 : this.weight;
    }

    isBlocking() {
        return this.weight === 0;
    }

    toString() {
        return '[' + this.x + ', ' + this.y + ']';
    }
}
